
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { HelmetProvider } from 'react-helmet-async';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import { AuthProvider } from "./providers/AuthProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import { AppRoutes } from "./AppRoutes";
import { queryClient } from "./queryClient";

const App = () => {
  return (
    <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <ErrorBoundary>
                <div className="min-h-screen flex flex-col">
                  <NavigationBar />
                  <AppRoutes />
                  <Footer />
                </div>
              </ErrorBoundary>
            </BrowserRouter>
            <Analytics />
            <SpeedInsights />
        </TooltipProvider>
      </AuthProvider>
    </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
